/**
 * 프리렌더 빌드(prerender.mjs 의 Playwright context `userAgent: 'XTrading-Prerenderer/1.0'`)에서 도는지.
 *
 * 쓰는 곳 — 정적 HTML 에 «구우면 안 되는 것»을 거른다:
 *  - 원화 환산 조각(features/institutions — 며칠 묵은 «현재 환율»이 색인되는 것 방지). 원래 krw.ts 에 있던 함수를 여기로 옮겼다.
 *  - 쿠키 동의 배너(TRAD-3792 — 프리렌더 브라우저는 동의 전 opt-in 상태라 배너가 스냅샷에 찍혀 dev·운영 정적 HTML 에 들어가 있었다).
 * 🔴 두 벌 두지 말 것 — UA 문자열이 바뀌면 한 곳만 고쳐진다.
 */
export const isPrerenderUserAgent = (userAgent: string | null | undefined): boolean =>
  /XTrading-Prerenderer/i.test(userAgent ?? '');

/** 지금 이 런타임이 프리렌더 브라우저인가 — 전역(navigator)을 읽는 경계. navigator 가 없으면(Node) false. */
export const isPrerenderRuntime = (): boolean =>
  typeof navigator !== 'undefined' && isPrerenderUserAgent(navigator.userAgent);
